import React from "react";
import { DEALER } from "@/data/dealership";
import { useT } from "@/i18n/lang";
import { Phone, Globe } from "lucide-react";

export default function Navbar() {
  const { t, lang, setLang } = useT();
  const [scrolled, setScrolled] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const nav = [
    { label: t("nav.inventory"), href: "#inventory", key: "inventory" },
    { label: t("nav.appointment"), href: "#appointment", key: "appointment" },
    { label: t("nav.about"), href: "#about", key: "about" },
    { label: t("nav.contact"), href: "#contact", key: "contact" },
  ];

  const otherLang = lang === "en" ? "es" : "en";

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/85 border-b border-[#E4E4E7]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between gap-6">
        <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo">
          <div className="w-9 h-9 bg-[#EB0A1E] flex items-center justify-center text-white font-display font-bold">
            JP
          </div>
          <div className="leading-tight hidden sm:block">
            <div className="font-display font-bold text-sm text-[#0A0A0A]">Joel Perez</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#52525B]">AutoNation Toyota South Austin</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((item) => (
            <a
              key={item.key}
              href={item.href}
              data-testid={`nav-link-${item.key}`}
              className="text-sm font-medium text-[#0A0A0A] hover:text-[#EB0A1E] transition-colors relative after:absolute after:bottom-[-4px] after:left-0 after:w-0 after:h-[2px] after:bg-[#EB0A1E] after:transition-all hover:after:w-full"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={() => setLang(otherLang)}
            data-testid="lang-toggle"
            aria-label={t("lang.tooltip")}
            title={t("lang.tooltip")}
            className="inline-flex items-center gap-1.5 border border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white px-3 py-2 text-xs font-bold tracking-wider transition-colors"
          >
            <Globe className="w-3.5 h-3.5" />
            {t("lang.toggle")}
          </button>
          <a
            href={`tel:${DEALER.phoneRaw}`}
            data-testid="nav-call-btn"
            className="inline-flex items-center gap-2 bg-[#EB0A1E] hover:bg-[#CC0011] text-white px-4 md:px-5 py-2.5 text-sm font-semibold transition-colors"
          >
            <Phone className="w-4 h-4" />
            <span className="hidden sm:inline">{DEALER.phone}</span>
            <span className="sm:hidden">{t("nav.callJoel")}</span>
          </a>
        </div>
      </div>
    </header>
  );
}
